import { jwtToken } from '../helpers'

const app = {
    apiUrl: '/backend/api',
    jwt: jwtToken(),
    name: 'ChurCH',
}

export default app
